export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'fa fa-dashboard'
        },
        {
            name: 'Log Stok',
            url: '/log-stok',
            icon: 'fa fa-clipboard'
        },
        {
            name: 'Order',
            url: '/order',
            icon: 'fa fa-book'
        },
        {
            name: 'Invoice',
            url: '/invoice',
            icon: 'fa fa-ticket'
        },
        {
            title: true,
            name: 'Master'
        },
        {
            name: 'Kategori',
            url: '/kategori',
            icon: 'fa fa-cubes'
        },
        {
            name: 'Model',
            url: '/model',
            icon: 'fa fa-cube'
        },
        {
            name: 'Users',
            url: '/user',
            icon: 'fa fa-user'
        }
    ]
}
